module.exports = __webpack_public_path__ + "img/sceneIcon1-2.e38d9276.png";